module.exports = __webpack_public_path__ + "img/logoD.002ee87a.jpeg";